// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"70e61c42","453":"61e50db6","963":"fc945bad"}[chunkId] + ".chunk.js";
};